import { Box, Drawer } from "@mui/material";

import React from "react";
import { HEADER_HEIGHT, SIDEBAR_WIDTH } from "../../../../Common/Constants";
import { Logo } from "../../../../Common/Components";

interface IMobileSidebar {
  isOpen: boolean;
  children: React.JSX.Element;
}
export const MobileSidebar: React.FC<IMobileSidebar> = (props) => {
  const { isOpen, children } = props;
  return (
    <Drawer
      open={isOpen}
      anchor="left"
      sx={(theme) => ({
        flexShrink: { md: 0 },
        //zIndex: 1290,

        ".MuiDrawer-paper": {
          [theme.breakpoints.down("md")]: {
            width: `${SIDEBAR_WIDTH}px`,
          },
        },
      })}
    >
      <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
        <Box
          sx={(theme) => ({
            px: 3,
            backgroundColor: theme.palette.grey[100],
            minHeight: HEADER_HEIGHT,
            display: "flex",
            flex: 0,
          })}
        >
          <Logo to={import.meta.env.VITE_LANDING_PAGE_URL} />
        </Box>

        {children}
      </Box>
    </Drawer>
  );
};
